import { render, staticRenderFns } from "./nologin.vue?vue&type=template&id=14ea2be2&"
import script from "./nologin.vue?vue&type=script&lang=js&"
export * from "./nologin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports